import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom'
import * as Isr from 'react-instantsearch/dom';
import { connectHits, connectSearchBox } from 'react-instantsearch/connectors';
//import Search from './search';

import axios from 'axios'

class InstantSearch extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searches: [],
      showHits: false
    }

    let that = this

    // Get most searched queries
    axios({
      method: 'get',
      url: '/2/searches',
      baseURL: 'https://analytics.algolia.com',
      headers: {
        'X-Algolia-Application-ID': 'IRBKNXT5J5',
        'X-Algolia-API-Key': 'd32966b55a6036c01f221ff4be296168'
      },
      params: {
        index: 'dev-santander-tpv-faq-real-idx'
      },
    }).then( resp => {
      console.log("resppp", resp)
      let searches = resp.data.searches.filter(search => search)
      that.setState({
        searches
      })
    })
  }

  render() {
    return (
      <Isr.InstantSearch
        appId="IRBKNXT5J5"
        apiKey="d52ef9abb0bd5d261b88c45fa624725e"
        indexName="dev-santander-tpv-faq-real-idx"
      //  resultsState={[]}
      //  createURL={searchState => console.log(searchState)}
      >
      <Isr.Configure hitsPerPage={5} /> 
        <Search mostSearches={this.state.searches}/>
      </Isr.InstantSearch>
    );
  }
}

class Search extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { mostSearches, ...props } = this.props
    console.log("Proper", props)
    return (
      <div className="container">
        {/* <Isr.ClearAll/> */}
        <Isr.SearchBox showLoadingIndicator={true}/>
        <p />
        <p style={{
          fontWeight: '700'
        }}>
          Busquedas populares:
        {
            mostSearches.map((item, idx) => (
              <span key={idx}>  {item.search}</span>
            ))
          }
        </p>
        <CustomSearchBox />
        
        {/* <Isr.Pagination /> */}
      </div>
    );
  }
}

const CustomSearchBox = connectSearchBox(({ currentRefinement, ...props }) => {
  console.log("currewrm", currentRefinement)
  if (currentRefinement && currentRefinement.length > 1) {
    return <Isr.Hits hitComponent={Product} />
  }
  else {
    return ""
  }
}
);


const Product = ({hit}) => {
  return (
    <div style={{marginTop: '10px'}}>
      <span className="hit-name">
        <Link
          to={`/faq/${hit.slug}`}>
          {hit.question}
      </Link>
      </span>
    </div>

  );
};

export default InstantSearch;


// WEBPACK FOOTER //
// ./src/components/InstantSearch.js